import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateTimeUtilsService } from '@dol/date-time-utils';

@Injectable()
export class DateService {
  constructor(
    private readonly dateTimeUtilService: DateTimeUtilsService,
    private readonly datePipe: DatePipe
  ) {}

  public getAcceptableDateFormats(): string[] {
    let localeFormat = this.dateTimeUtilService.getCustomLocaleDateFormat(0, true);

    if (this.charLength(localeFormat, 'y') < 4) {
      localeFormat = this.replaceAllOccurenceWith(localeFormat, 'y', 'YYYY');
    }

    if (this.charLength(localeFormat, 'd') < 2) {
      localeFormat = this.replaceAllOccurenceWith(localeFormat, 'd', 'dd');
    }
    if (this.charLength(localeFormat, 'm') < 2) {
      localeFormat = this.replaceAllOccurenceWith(localeFormat, 'm', 'MM');
    }

    //Returning array as to support aditional formats in future
    return [localeFormat];
  }

  private charLength(string: string, character: string): number {
    const word = string.toLowerCase();
    const letter = character.toLowerCase();
    return word.lastIndexOf(letter) - word.indexOf(letter) + 1;
  }

  private replaceAllOccurenceWith(string: string, char: string, replaceWith: string): string {
    const firstIndex = string.toLowerCase().indexOf(char.toLowerCase());
    const lastIndex = string.toLowerCase().lastIndexOf(char.toLowerCase());
    return string.substring(0, firstIndex) + replaceWith + string.substring(lastIndex + 1);
  }
  public formatDate(dateTimeValue: string | null | undefined): string {
    if (dateTimeValue && dateTimeValue.trim() !== '') {
      const short = 0;
      const shortDateTimeFormat: string = this.dateTimeUtilService.getCustomLocaleDateFormat(short, false);
      return dateTimeValue ? (this.datePipe.transform(new Date(dateTimeValue), shortDateTimeFormat)?.replace(',', '') ?? '') : '';
    }
    return '';
  }
}
